import { makeFupIcon } from './FupIconFactory';
export default makeFupIcon('ADD');
